import { createAction } from 'redux-actions';

export const clearVersion = createAction('Version/CLEAR_ALL');
export const setVersion = createAction('Version/SET');
